import axios from "axios";
import router from "@/router";
import baseURL from "@/utils/url";
import {
    ElMessage as Message
} from "element-plus";

let isLoggingOut = false;

function handleLogout() {
    if (isLoggingOut) return;
    isLoggingOut = true;

    localStorage.removeItem("userId");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");

    Message.error("登录状态已失效，请重新登录");

    router.replace("/login");

    setTimeout(() => {
        isLoggingOut = false;
    }, 2000);
}
// 使用自定义的配置文件发送请求
const instance = axios.create({
    baseURL: baseURL,
    timeout: 9999999999,
    headers: {
        "Content-Type": "multipart/form-data",
    },
});
// 需要token的接口
let tokenWhite = [
    "/api/userInfo",
    "/api/aitext",
    "/api/aizhuti",
    "/api/aiphoto",
    "/api/aifenjing",
    "/api/aifenjingmp3",
    "/api/shiting",
    "/api/aifenjingphoto",
    "/api/aivideo",
    "/api/hebingvideo",
    "/api/alipaywebpay",
    "/api/ainewChapterSubjectlist",
    "/api/ainewChapterStoryFenjinglist",
    "/api/ainewChapterFinalVideolist",
    "/api/team/subAccount/create",
    "/api/team/subAccount/list",
    "/api/team/subAccount/update",
    "/api/team/subAccount/delete",
    "/api/team/create",
    "/api/team/myCreatedTeams",
    "/api/team/update",
    "/api/team/dissolve",
    "/api/team/memberList",
    "/api/team/batchBindMembers",
    "/api/team/removeMember",
    "/api/team/updateMemberRole",
    "/api/team/myStorage",
    "/api/ainewProjectremove",
    "/api/ainewProjectadd",
    "/api/ainewProjectChapteradd",
    "/api/ainewProjectedit",
    "/api/ainewProjectChapteredit"
];
// 添加请求拦截器
instance.interceptors.request.use(
    function(config) {
        if (tokenWhite.includes(config.url)) {
            if (localStorage.getItem("token")) {
                config.headers["token"] = localStorage.getItem("token");
            } else {
                handleLogout();
            }
        }

        // 可以设置token
        // config.header["token"] = "";
        // config.header["content-type"] = "multipart/form-data";
        return config;
    },
    function(error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    },
);

instance.interceptors.response.use(
    (response) => {
        if (!response || typeof response.data !== "object") {
            const errMsg = "接口响应数据格式异常";
            Message.error(errMsg);
            return Promise.reject(new Error(errMsg));
        }

        const {
            code,
            msg
        } = response.data;

        if (msg == 401) {
            handleLogout();
            return response.data;
        }

        if (code !== 200) {
            Message.error(msg || `请求失败（错误码：${code}）`);
            // 业务错误统一返回给页面处理，避免触发未捕获 Promise 导致控制台报错
            return response.data;
        }

        return response.data;
    },
    (error) => {
        let errMsg = "网络请求异常，请稍后重试";

        if (error.response) {
            const {
                status,
                data
            } = error.response;

            if (status === 401) {
                handleLogout();
                return Promise.reject(error);
            }

            errMsg = (data && data.msg) || `服务器错误（${status}）`;
        } else if (error.request) {
            errMsg = "请求超时，请检查网络连接";
        }

        Message.error(errMsg);
        return Promise.reject(error);
    },
);
export default instance;